var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { bindActionCreators } from 'redux';
import { actions as preferencesActions } from '../Redux/slices/Preferences/preferences';
import { actions as reports } from '../Redux/slices/Reports/reports';
import { actions as hands } from '../Redux/slices/handsSlice';
import { actions as trainerSettings } from '../Redux/slices/trainerSettings';
import { actions as dashboard } from '../Redux/slices/userDashboard';
import { actions as trainer } from '../Redux/slices/trainer';
import { useTypeDispatch } from './useTypeHooks';
var actions = __assign(__assign(__assign(__assign(__assign(__assign({}, preferencesActions), reports), hands), trainerSettings), dashboard), trainer);
export var useActions = function () {
    var dispatch = useTypeDispatch();
    return bindActionCreators(actions, dispatch);
};
